import styled from 'styled-components';
import { devices } from '../../../styles/viewports';

export const CardContainer = styled.div`
  cursor: pointer;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 15px;
  min-height: 50px;
`;

export const ContentContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const StyledImage = styled.img`
  border: 1px solid var(--base-color-white);
`;

export const ImageWrapper = styled.div`
  position: relative;
`;

export const IconWrapper = styled.div`
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    width: 40px;
    height: 40px;
    @media ${devices.tablet} {
      width: 24px;
      height: 24px;
    }
    @media ${devices.mobile} {
      width: 18px;
      height: 18px;
    }
  }
`;

export const TitleWrapper = styled.div`
  margin-top: 8px;
  div {
    @media ${devices.mobile} {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;
